// file: `react/src/components/FarfarNavbar.tsx`:

import React from 'react';
import { Link } from 'react-router-dom';
import { Navbar, Nav, Container, NavDropdown } from 'react-bootstrap';
import { useUser } from '../UserContext.tsx';
import {
  canViewPastoralPrompts,
  canViewReviewQueue,
  canViewSafeguardingCases
} from '../../school/schoolClaims.ts';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCog, faSignOutAlt, faUser } from '@fortawesome/free-solid-svg-icons'; // Example icon
import './FarfarNavbar.scss';

function FarfarNavbar() {
  const { activeUser } = useUser();

  //console.log('FarfarNavbar activeUser', activeUser);

  if (!activeUser || !activeUser.email) {
    //console.log('FarfarNavbar: Missing activeUser or activeUser’s email')
    //return null; // Render nothing until activeUser is defined
    // return (
    //   <div>
    //     FarfarNavbar.tsx: Placeholder content when not logged in
    //     <Nav.Link as={Link} to="/about">About</Nav.Link>
    //     <Nav.Link as={Link} to="/prompt">Prompt</Nav.Link>
    //   </div>
    // )
  } 
  //else { console.log('FarfarNavbar activeUser:', activeUser); }

  return (
    <Navbar expand="sm" className='navbar'>
      <Container fluid>
        <Navbar.Brand as={Link} to="/">ƒarƒar</Navbar.Brand>
        <Nav className="ms-auto">
          {canViewPastoralPrompts(activeUser) && (
            <Nav.Link as={Link} to="/school/prompts">
              School notices
            </Nav.Link>
          )}
          {canViewSafeguardingCases(activeUser) && (
            <Nav.Link as={Link} to="/school/cases">
              Safeguarding cases
            </Nav.Link>
          )}
          {canViewReviewQueue(activeUser) && (
            <Nav.Link as={Link} to="/school/review">
              Blinded review
            </Nav.Link>
          )}
          {activeUser?.email && (
            <>
              <Nav.Link as={Link} to="/recovery">
                Recovery circle
              </Nav.Link>
              <Nav.Link as={Link} to="/access">
                Court-access drill
              </Nav.Link>
            </>
          )}
          <NavDropdown
            title={<div className="avatar-circle">{activeUser ? activeUser.shortName?.charAt(0) : <FontAwesomeIcon icon={faUser} />}</div>}
            id="collapsible-nav-dropdown"
            align="end">
            <NavDropdown.ItemText>
            <FontAwesomeIcon icon={faUser} /> &nbsp;
            {activeUser?.fullName ?? 'Visitor'}</NavDropdown.ItemText>
            <NavDropdown.Item as={Link} to={activeUser ? '/logout' : '/login'}>
            <FontAwesomeIcon icon={faSignOutAlt} /> &nbsp;
            {activeUser ? 'Logout' : 'Login'}</NavDropdown.Item>
            <hr />
            <NavDropdown.Item as={Link} to="/account">
            <FontAwesomeIcon icon={faUser} /> &nbsp;
            Account</NavDropdown.Item>
            <NavDropdown.Item as={Link} to="/settings">
            <FontAwesomeIcon icon={faCog} /> &nbsp;
            Settings</NavDropdown.Item>
            <hr />
            <NavDropdown.Item as={Link} to="/devops">
            DevOps</NavDropdown.Item>
          </NavDropdown>
        </Nav>
      </Container>
    </Navbar>
  );
}

export default FarfarNavbar;